module.exports = __webpack_public_path__ + "img/CSS-02.2f4fd343.svg";